import React from "react";

const SocialInfo = (props) => {
  return (
    <div className="card">
      <h3>Social Media</h3>
      <div className="card-body">
        {props.data?.uncommonNewData?.twitter && (
          <div class="datas">
            <p>Twitter:</p>
            <del>{props.data?.uncommonOldData?.twitter}</del>
            <span>{props.data?.uncommonNewData?.twitter}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.instagram && (
          <div class="datas">
            <p>Instagram:</p>
            <del>{props.data?.uncommonOldData?.instagram}</del>
            <span>{props.data?.uncommonNewData?.instagram}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.facebook && (
          <div class="datas">
            <p>Facebook:</p>
            <del>{props.data?.uncommonOldData?.facebook}</del>
            <span>{props.data?.uncommonNewData?.facebook}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.youTube && (
          <div class="datas">
            <p>YouTube:</p>
            <del>{props.data?.uncommonOldData?.youTube}</del>
            <span>{props.data?.uncommonNewData?.youTube}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.agl && (
          <div class="datas">
            <p>Athlete's Go Live:</p>
            <del>{props.data?.uncommonOldData?.agl}</del>
            <span>{props.data?.uncommonNewData?.agl}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.hudl && (
          <div class="datas">
            <p>Hudl:</p>
            <del>{props.data?.uncommonOldData?.hudl}</del>
            <span>{props.data?.uncommonNewData?.hudl}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default SocialInfo;
